module.exports = __webpack_public_path__ + "static/media/img1.7265273d.jpg";